import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentDataService } from "../../../../redux/actions/dbactions/pateints";
import { CustomCard } from "../../../CustomCard";
import { Icon } from "@iconify/react";

export const ServiceCard = ({
  data,
  HandleClick,
  selectedColor,
  isDisabled,
  dispatch,
}) => {
  const [showMore, setShowMore] = useState(false);
  const { refsdata } = useSelector((state) => state.refstypes);
  const {
    svc_name,
    svc_cat_desc,
    svc_typ_desc,
    svc_desc,
    svc_cost_amt,
    svc_provider_local_cost_amt,
    svc_id,
    svc_photo1,
  } = data;
  const history = useHistory();
  const xchange_rate = refsdata.usr?.iso_currency_xchng || [];
  const shouldText = svc_desc.length > 100;
  const displayText = showMore
    ? svc_desc
    : `${svc_desc.slice(0, 100)}${shouldText ? "..." : ""}`;
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const handleBookie = () => {
    dispatch(setCurrentDataService(data));
    history.push(`/dashboard/explore/${svc_id}/patient-profiles`);
  };
  const svc_cost_amtf = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(svc_cost_amt);
  const svc_provider_local_cost_amtf = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(svc_provider_local_cost_amt);
  return (
    <CustomCard className="facility patient-card">
      <div
        className="d-flex justify-content-between align-items-center !mb-4"
        style={{ borderBottom: "1px solid #E7E7E9" }}
      >
        <div className="d-flex align-items-center justify-content-center gap-2">
          <div className="flex gap-2">
            {svc_photo1 ? (
              <img src={svc_photo1} className="w-12 h-12 rounded-full" />
            ) : (
              <Icon
                icon="streamline-emojis:hospital"
                style={{ fontSize: "40px" }}
              />
            )}

            <div>
              <h5 className="!text-base m-0 !text-main">{svc_name}</h5>
              <p className="!text-description !font-normal">
                #{svc_id} &nbsp;
                {displayText}
                {shouldText && (
                  <span onClick={toggleShowMore}>
                    {" "}
                    {showMore ? "Show Less" : "Show More"}
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row gap-y-[18px]">
        <div className="col-6">
          <small>Service Category :</small>
          <p className="truncate mb-0">{svc_cat_desc}</p>
        </div>
        <div className="col-6">
          <small>Service Type:</small>
          <p className="truncate mb-0">{svc_typ_desc}</p>
        </div>
        <div className="col-6">
          <small> {xchange_rate[0]?.iso_curr_name}:</small>
          <p className="truncate mb-0">{svc_provider_local_cost_amtf}</p>
        </div>
        <div className="col-6">
          <small>Service Code (USD) :</small>
          <p className="truncate mb-0">{svc_cost_amtf}</p>
        </div>

        <div className=" flex justify-start">
          <button
            className="sign_btn !w-full !text-xs"
            // disabled={isDisabled === svc_id ? false : true}
            style={{ boxSizing: "border-box" }}
            onClick={handleBookie}
          >
            Book Appointment
          </button>
        </div>
      </div>
    </CustomCard>
  );
};
